import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import {
  ATIVO_OPTIONS, ATTENDANCE_OPTIONS, registrationOption, registrationPeriodLabel, registrationRange, REGISTRATION_OPTIONS,
  validateRegistrationPeriod,
} from '../../utilities/dashboard'

// Filtros da aba Pacientes, numa linha acima de tudo: situação do cadastro, atendimento recente e data de cadastro
// (Este ano e Últimos 12 meses vão até agora; Personalizar aceita só o início, só o fim ou os dois)
const PacientesFilters = ({ filters, today, onChange }) => {
  const option = registrationOption(filters, today)
  const [custom, setCustom] = useState(option === 'CUSTOM')
  const [customStart, setCustomStart] = useState(filters.start_date)
  const [customEnd, setCustomEnd] = useState(filters.end_date)
  const [customError, setCustomError] = useState('')

  function selectRegistration(value) {
    setCustomError('')
    if (value === 'CUSTOM') {
      setCustomStart(filters.start_date)
      setCustomEnd(filters.end_date)
      return setCustom(true)
    }
    setCustom(false)
    onChange({ ...filters, ...registrationRange(value, today) })
  }

  function applyCustom() {
    const error = validateRegistrationPeriod(customStart, customEnd, today)
    if (error) return setCustomError(error.message)
    setCustomError('')
    onChange({ ...filters, start_date: customStart, end_date: customEnd })
  }

  return (
    <div className='dashboard-filters' role='group' aria-label='Filtros da aba Pacientes'>
      <Form.Group className='dashboard-filter'>
        <Form.Label htmlFor='dashboard-pacientes-ativo'>Situação</Form.Label>
        <Form.Select id='dashboard-pacientes-ativo' size='sm' value={filters.ativo} onChange={(e) => onChange({ ...filters, ativo: e.target.value })}>
          {ATIVO_OPTIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
        </Form.Select>
      </Form.Group>

      <Form.Group className='dashboard-filter'>
        <Form.Label htmlFor='dashboard-pacientes-attendance'>Atendimento</Form.Label>
        <Form.Select id='dashboard-pacientes-attendance' size='sm' value={filters.attendance} onChange={(e) => onChange({ ...filters, attendance: e.target.value })}>
          {ATTENDANCE_OPTIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
        </Form.Select>
      </Form.Group>

      <div className='dashboard-filter'>
        <Form.Label htmlFor='dashboard-pacientes-registration'>Data de cadastro</Form.Label>
        <div className='dashboard-period'>
          <Form.Select id='dashboard-pacientes-registration' size='sm' value={custom ? 'CUSTOM' : option} onChange={(e) => selectRegistration(e.target.value)}>
            {REGISTRATION_OPTIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
          </Form.Select>
          {custom ?
            <>
              <Form.Control type='date' size='sm' aria-label='Cadastro a partir de' value={customStart} max={today} onChange={(e) => setCustomStart(e.target.value)} />
              <span className='dashboard-period-sep'>a</span>
              <Form.Control type='date' size='sm' aria-label='Cadastro até' value={customEnd} min={customStart || undefined} onChange={(e) => setCustomEnd(e.target.value)} />
              <Button variant='primary' size='sm' onClick={applyCustom}>Aplicar</Button>
            </>
            : ''}
        </div>
        {customError ? <small className='dashboard-filter-error' role='alert'>{customError}</small> : ''}
      </div>

      <span className='dashboard-period-text' aria-live='polite'>Cadastro: {registrationPeriodLabel(filters, today)}</span>
    </div>
  )
}

export default PacientesFilters
